import CardTemplateService from "../../services/CardTemplateService";
import { I18n } from "react-redux-i18n";

// Action Types
export const CARD_TEMPLATE_ACTIONS = {
    // Template Management
    GET_TEMPLATES_REQUEST: 'GET_TEMPLATES_REQUEST',
    GET_TEMPLATES_SUCCESS: 'GET_TEMPLATES_SUCCESS',
    GET_TEMPLATES_FAILURE: 'GET_TEMPLATES_FAILURE',

    GET_TEMPLATE_DETAILS_REQUEST: 'GET_TEMPLATE_DETAILS_REQUEST',
    GET_TEMPLATE_DETAILS_SUCCESS: 'GET_TEMPLATE_DETAILS_SUCCESS',
    GET_TEMPLATE_DETAILS_FAILURE: 'GET_TEMPLATE_DETAILS_FAILURE',

    CREATE_TEMPLATE_REQUEST: 'CREATE_TEMPLATE_REQUEST',
    CREATE_TEMPLATE_SUCCESS: 'CREATE_TEMPLATE_SUCCESS',
    CREATE_TEMPLATE_FAILURE: 'CREATE_TEMPLATE_FAILURE',

    UPDATE_TEMPLATE_REQUEST: 'UPDATE_TEMPLATE_REQUEST',
    UPDATE_TEMPLATE_SUCCESS: 'UPDATE_TEMPLATE_SUCCESS',
    UPDATE_TEMPLATE_FAILURE: 'UPDATE_TEMPLATE_FAILURE',

    DELETE_TEMPLATE_REQUEST: 'DELETE_TEMPLATE_REQUEST',
    DELETE_TEMPLATE_SUCCESS: 'DELETE_TEMPLATE_SUCCESS',
    DELETE_TEMPLATE_FAILURE: 'DELETE_TEMPLATE_FAILURE',

    DUPLICATE_TEMPLATE_REQUEST: 'DUPLICATE_TEMPLATE_REQUEST',
    DUPLICATE_TEMPLATE_SUCCESS: 'DUPLICATE_TEMPLATE_SUCCESS',
    DUPLICATE_TEMPLATE_FAILURE: 'DUPLICATE_TEMPLATE_FAILURE',

    // Template Preview
    PREVIEW_TEMPLATE_REQUEST: 'PREVIEW_TEMPLATE_REQUEST',
    PREVIEW_TEMPLATE_SUCCESS: 'PREVIEW_TEMPLATE_SUCCESS',
    PREVIEW_TEMPLATE_FAILURE: 'PREVIEW_TEMPLATE_FAILURE',

    GET_TEMPLATE_PREVIEW_REQUEST: 'GET_TEMPLATE_PREVIEW_REQUEST',
    GET_TEMPLATE_PREVIEW_SUCCESS: 'GET_TEMPLATE_PREVIEW_SUCCESS',
    GET_TEMPLATE_PREVIEW_FAILURE: 'GET_TEMPLATE_PREVIEW_FAILURE',

    TEST_TEMPLATE_REQUEST: 'TEST_TEMPLATE_REQUEST',
    TEST_TEMPLATE_SUCCESS: 'TEST_TEMPLATE_SUCCESS',
    TEST_TEMPLATE_FAILURE: 'TEST_TEMPLATE_FAILURE',

    // Default Templates
    GET_DEFAULT_TEMPLATES_REQUEST: 'GET_DEFAULT_TEMPLATES_REQUEST',
    GET_DEFAULT_TEMPLATES_SUCCESS: 'GET_DEFAULT_TEMPLATES_SUCCESS',
    GET_DEFAULT_TEMPLATES_FAILURE: 'GET_DEFAULT_TEMPLATES_FAILURE',

    SET_DEFAULT_TEMPLATE_REQUEST: 'SET_DEFAULT_TEMPLATE_REQUEST',
    SET_DEFAULT_TEMPLATE_SUCCESS: 'SET_DEFAULT_TEMPLATE_SUCCESS',
    SET_DEFAULT_TEMPLATE_FAILURE: 'SET_DEFAULT_TEMPLATE_FAILURE',

    // Card Management
    GET_CARD_REQUEST: 'GET_CARD_REQUEST',
    GET_CARD_SUCCESS: 'GET_CARD_SUCCESS',
    GET_CARD_FAILURE: 'GET_CARD_FAILURE',

    GET_BENEFICIARY_CARDS_REQUEST: 'GET_BENEFICIARY_CARDS_REQUEST',
    GET_BENEFICIARY_CARDS_SUCCESS: 'GET_BENEFICIARY_CARDS_SUCCESS',
    GET_BENEFICIARY_CARDS_FAILURE: 'GET_BENEFICIARY_CARDS_FAILURE',

    // Card Production
    INITIATE_PRODUCTION_REQUEST: 'INITIATE_PRODUCTION_REQUEST',
    INITIATE_PRODUCTION_SUCCESS: 'INITIATE_PRODUCTION_SUCCESS',
    INITIATE_PRODUCTION_FAILURE: 'INITIATE_PRODUCTION_FAILURE',

    GET_PRODUCTION_STATUS_REQUEST: 'GET_PRODUCTION_STATUS_REQUEST',
    GET_PRODUCTION_STATUS_SUCCESS: 'GET_PRODUCTION_STATUS_SUCCESS',
    GET_PRODUCTION_STATUS_FAILURE: 'GET_PRODUCTION_STATUS_FAILURE',

    UPDATE_PRODUCTION_STEP_REQUEST: 'UPDATE_PRODUCTION_STEP_REQUEST',
    UPDATE_PRODUCTION_STEP_SUCCESS: 'UPDATE_PRODUCTION_STEP_SUCCESS',
    UPDATE_PRODUCTION_STEP_FAILURE: 'UPDATE_PRODUCTION_STEP_FAILURE',

    // Card Preview and Print
    GENERATE_CARD_PREVIEW_REQUEST: 'GENERATE_CARD_PREVIEW_REQUEST',
    GENERATE_CARD_PREVIEW_SUCCESS: 'GENERATE_CARD_PREVIEW_SUCCESS',
    GENERATE_CARD_PREVIEW_FAILURE: 'GENERATE_CARD_PREVIEW_FAILURE',

    PRINT_CARD_REQUEST: 'PRINT_CARD_REQUEST',
    PRINT_CARD_SUCCESS: 'PRINT_CARD_SUCCESS',
    PRINT_CARD_FAILURE: 'PRINT_CARD_FAILURE',

    BATCH_PRINT_CARDS_REQUEST: 'BATCH_PRINT_CARDS_REQUEST',
    BATCH_PRINT_CARDS_SUCCESS: 'BATCH_PRINT_CARDS_SUCCESS',
    BATCH_PRINT_CARDS_FAILURE: 'BATCH_PRINT_CARDS_FAILURE',

    // UI Actions
    SET_TEMPLATE_FILTER: 'SET_TEMPLATE_FILTER',
    SET_SELECTED_TEMPLATE: 'SET_SELECTED_TEMPLATE',
    SET_SELECTED_CARD: 'SET_SELECTED_CARD',
    CLEAR_TEMPLATE_ERRORS: 'CLEAR_TEMPLATE_ERRORS',
    SET_TEMPLATE_VIEW: 'SET_TEMPLATE_VIEW'
};

// Template Management Actions
export const getTemplates = (filters = {}) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATES_REQUEST });

        const result = await CardTemplateService.getTemplates(filters);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATES_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.loadFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATES_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const getTemplateDetails = (templateId) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_DETAILS_REQUEST });

        const result = await CardTemplateService.getTemplateById(templateId);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_DETAILS_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.detailsLoadFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_DETAILS_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const createTemplate = (templateData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.CREATE_TEMPLATE_REQUEST });

        const result = await CardTemplateService.createTemplate(templateData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.CREATE_TEMPLATE_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.createFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.CREATE_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const updateTemplate = (templateId, templateData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.UPDATE_TEMPLATE_REQUEST });

        const result = await CardTemplateService.updateTemplate(templateId, templateData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.UPDATE_TEMPLATE_SUCCESS,
            payload: { templateId, result }
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.updateFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.UPDATE_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const deleteTemplate = (templateId) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.DELETE_TEMPLATE_REQUEST });

        const result = await CardTemplateService.deleteTemplate(templateId);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.DELETE_TEMPLATE_SUCCESS,
            payload: templateId
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.deleteFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.DELETE_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const duplicateTemplate = (templateId, duplicateData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.DUPLICATE_TEMPLATE_REQUEST });

        const result = await CardTemplateService.duplicateTemplate(templateId, duplicateData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.DUPLICATE_TEMPLATE_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.duplicateFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.DUPLICATE_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// Template Preview Actions
export const previewTemplate = (previewData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.PREVIEW_TEMPLATE_REQUEST });

        const result = await CardTemplateService.previewTemplate(previewData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.PREVIEW_TEMPLATE_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.previewFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.PREVIEW_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const getTemplatePreview = (templateId, side) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_PREVIEW_REQUEST });

        const blob = await CardTemplateService.getTemplatePreview(templateId, side);
        const previewUrl = CardTemplateService.createPreviewUrl(blob);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_PREVIEW_SUCCESS,
            payload: { templateId, side, previewUrl, blob }
        });

        return { success: true, data: { previewUrl, blob } };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.previewImageFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_TEMPLATE_PREVIEW_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// Card Management Actions
export const getBeneficiaryCards = (beneficiaryId) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_BENEFICIARY_CARDS_REQUEST });

        const result = await CardTemplateService.getCardsByBeneficiary(beneficiaryId);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_BENEFICIARY_CARDS_SUCCESS,
            payload: { beneficiaryId, cards: result }
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.cardsLoadFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_BENEFICIARY_CARDS_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// Card Production Actions
export const initiateCardProduction = (productionData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.INITIATE_PRODUCTION_REQUEST });

        const result = await CardTemplateService.initiateCardProduction(productionData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.INITIATE_PRODUCTION_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.productionInitiateFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.INITIATE_PRODUCTION_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const getProductionStatus = (cardId) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_PRODUCTION_STATUS_REQUEST });

        const result = await CardTemplateService.getProductionStatus(cardId);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_PRODUCTION_STATUS_SUCCESS,
            payload: { cardId, status: result }
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.productionStatusFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_PRODUCTION_STATUS_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// Card Preview and Print Actions
export const generateCardPreview = (cardId, templateId = null) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GENERATE_CARD_PREVIEW_REQUEST });

        const blob = await CardTemplateService.generateCardPreview(cardId, templateId);
        const previewUrl = CardTemplateService.createPreviewUrl(blob);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GENERATE_CARD_PREVIEW_SUCCESS,
            payload: { cardId, previewUrl, blob }
        });

        return { success: true, data: { previewUrl, blob } };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.cardPreviewFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GENERATE_CARD_PREVIEW_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const printCard = (cardId, printOptions = {}) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.PRINT_CARD_REQUEST });

        const blob = await CardTemplateService.printCard(cardId, printOptions);
        
        // Auto-download the card
        const cardNumber = printOptions.cardNumber || `card_${cardId}`;
        CardTemplateService.downloadFile(blob, `${cardNumber}.pdf`);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.PRINT_CARD_SUCCESS,
            payload: { cardId, blob }
        });

        return { success: true, data: { blob } };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.printFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.PRINT_CARD_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const batchPrintCards = (cardIds, printOptions = {}) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.BATCH_PRINT_CARDS_REQUEST });

        const blob = await CardTemplateService.batchPrintCards(cardIds, printOptions);
        
        // Auto-download the batch
        const timestamp = new Date().getTime();
        CardTemplateService.downloadFile(blob, `batch_cards_${timestamp}.pdf`);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.BATCH_PRINT_CARDS_SUCCESS,
            payload: { cardIds, blob }
        });

        return { success: true, data: { blob } };
    } catch (error) {
        const errorMessage = error.response?.data?.message || 
                           I18n.t('cardTemplate.error.batchPrintFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.BATCH_PRINT_CARDS_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// Default Templates Actions
export const getDefaultTemplates = (countryCode) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.GET_DEFAULT_TEMPLATES_REQUEST });

        const result = await CardTemplateService.getDefaultTemplates(countryCode);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_DEFAULT_TEMPLATES_SUCCESS,
            payload: result
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.defaultTemplatesLoadFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.GET_DEFAULT_TEMPLATES_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

export const setDefaultTemplate = (defaultData) => async (dispatch) => {
    try {
        dispatch({ type: CARD_TEMPLATE_ACTIONS.SET_DEFAULT_TEMPLATE_REQUEST });

        const result = await CardTemplateService.setDefaultTemplate(defaultData);

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.SET_DEFAULT_TEMPLATE_SUCCESS,
            payload: { defaultData, result }
        });

        return { success: true, data: result };
    } catch (error) {
        const errorMessage = error.response?.data?.error?.message || 
                           error.response?.data?.message || 
                           I18n.t('cardTemplate.error.setDefaultFailed');

        dispatch({
            type: CARD_TEMPLATE_ACTIONS.SET_DEFAULT_TEMPLATE_FAILURE,
            payload: errorMessage
        });

        return { success: false, error: errorMessage };
    }
};

// UI Actions
export const setTemplateFilter = (filter) => ({
    type: CARD_TEMPLATE_ACTIONS.SET_TEMPLATE_FILTER,
    payload: filter
});

export const setSelectedTemplate = (template) => ({
    type: CARD_TEMPLATE_ACTIONS.SET_SELECTED_TEMPLATE,
    payload: template
});

export const setSelectedCard = (card) => ({
    type: CARD_TEMPLATE_ACTIONS.SET_SELECTED_CARD,
    payload: card
});

export const clearTemplateErrors = () => ({
    type: CARD_TEMPLATE_ACTIONS.CLEAR_TEMPLATE_ERRORS
});

export const setTemplateView = (view) => ({
    type: CARD_TEMPLATE_ACTIONS.SET_TEMPLATE_VIEW,
    payload: view
});